import { useEffect } from 'react'
import { setTag, setUser } from '@chilipiper/sentry'
import { useFireSessionContext } from '@chilipiper/fire-session'

// Rendered inside FireSessionProvider so every event after boot carries the reporter's identity.
export const SentryUser = () => {
  const { userId, tenantId, user } = useFireSessionContext()

  useEffect(() => {
    setUser({ id: userId, email: user.email })
    setTag('tenant_id', tenantId)
  }, [userId, tenantId, user.email])

  return null
}
